import {createFeatureSelector} from '@ngrx/store';
import {Features} from '../features';
import {HistoriaNawigacji} from './historia-nawigacji';

export const selectHistoriaNawigacji = createFeatureSelector<HistoriaNawigacji>(Features.HISTORIA_NAWIGACJI)

